import { render, staticRenderFns } from "./FirstFormNewBg.vue?vue&type=template&id=13baab16&scoped=true&"
import script from "./FirstFormNewBg.vue?vue&type=script&lang=js&"
export * from "./FirstFormNewBg.vue?vue&type=script&lang=js&"
import style0 from "./FirstFormNewBg.vue?vue&type=style&index=0&id=13baab16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13baab16",
  null
  
)

export default component.exports